import LogoImg from "../images/logo.png";

export default function Logo() {
  return <img alt="bg" src={LogoImg} height="48" />;
}
